import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';
import classNames from 'classnames';
import SearchField from '../../components/SearchField';
import School from '../../components/School';
import Loader from '../../components/Loader';
/* eslint-disable import/no-named-as-default */
import Button from '../../components/Button';
import Mapbox from '../../components/Mapbox';
import FilterSelect from '../../components/FilterSelect';
import { withRtl } from '../../components/hoc';
import style from '../logged-in/LoggedIn.scss'; // eslint-disable-line css-modules/no-unused-class
import { getSchoolsPrograms } from '../../actions/schools';
import { getFilters } from '../../actions/filters';
import studentInfo from '../../actions/studentInfo';
import { getStudentApplications } from '../../actions/student';
import setPage from '../../actions/pagination';
import { addParameterAndSearch } from '../../actions/addParameter';
import schoolsToMarker from '../../services/schoolsToMarker';
import Default, { Mobile } from '../../utils/mediaQueries';
import SearchAndFilter from '../../components/SearchAndFilter';
import ResultsSetSort from '../../components/ResultsSetSort';
import SearchNoResults from '../../components/SearchNoResults';
import messages from '../../locale/messages';
import history from '../../history';
import { getSavedProgramCount, customisedIntlFormatMessage } from '../../utils/helpers';
import CoachmarksSaved from '../../coachmarksLocale/saved/saved';
import Coachmarks from '../../components/Coachmarks';

const localMessages = defineMessages({
  savedProgramsAlertBoxBeforeLinkText: {
    id: 'savedPrograms.AlertBoxBeforeLinkText',
    defaultMessage: `You've saved {savedProgramsCount} programs, shown below. Try`,
    description: 'Text that comes before link in the alert box',
    values: {
      savedProgramsCount: '0',
    },
  },
  savedProgramsAlertBoxLinkText: {
    id: 'savedPrograms.AlertBoxLinkText',
    defaultMessage: 'searching',
    description: 'Link text in the alert box',
  },
  savedProgramsAlertBoxAfterLinkText: {
    id: 'savedPrograms.AlertBoxAfterLinkText',
    defaultMessage: `and saving {freeProgramsSlot} more to prepare for building a complete and balanced application!`,
    description: 'Text that comes after link in the alert box',
    values: {
      freeProgramsSlot: '25',
    },
  },
  noSavedProgramsAlertBoxBeforeLinkText: {
    id: 'noSavedPrograms.AlertBoxBeforeLinkText',
    defaultMessage: `You haven't saved any programs! Try`,
    description: 'Text that comes before link in the alert box if no programs are saved',
  },
  noSavedProgramsAlertBoxAfterLinkText: {
    id: 'noSavedPrograms.AlertBoxAfterLinkText',
    defaultMessage: `and saving some, then return here to compare just your saved ones,`,
    description: 'Text that comes after link in the alert box',
  },
  noSavedProgramsAlertBoxAdditionalBeforeLinkText: {
    id: 'noSavedPrograms.AlertBoxAdditionalBeforeLinkText',
    defaultMessage: `Or if you know exactly which programs you want to apply to, you can skip ahead to the `,
    description: 'Text that comes after initial info text when no programs are saved',
  },
  noSavedProgramsAlertBoxApplyLinkText: {
    id: 'noSavedPrograms.AlertBoxApplyLinkText',
    defaultMessage: 'Apply',
    description: 'Link text in the alert box leading to the Apply page',
  },
  noSavedProgramsAlertBoxAdditionalAfterLinkText: {
    id: 'noSavedPrograms.AlertBoxAdditionalAfterLinkText',
    defaultMessage: `step.`,
    description: 'Text that comes after initial info text when no programs are saved',
  },
  studentAddressNotGeocoded: {
    id: 'savedPrograms.studentAddressNotGeocoded',
    defaultMessage:
      'Student’s residential address is not specified or\n' +
      'recognized. Zoned school and schools’ distances\n' +
      'from home are not shown. Eligibilities may be\n' +
      'inaccurate.',
    description: 'Student address is not geocoded.',
  },
});

// const SCHOOLS = 'SCHOOLS';
// const MAP = 'MAP';

class Saves extends Component {
  static propTypes = {
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    filtersLoaded: PropTypes.bool.isRequired,
    filtersLoading: PropTypes.bool.isRequired,
    schools: PropTypes.shape({
      autocomplete: PropTypes.shape({
        savedProgramSchoolsUnapplied: PropTypes.shape({
          autocompleteList: PropTypes.arrayOf(PropTypes.string),
          id: PropTypes.arrayOf(PropTypes.number),
        }),
      }).isRequired,
      optionsDict: PropTypes.shape({}).isRequired,
      loaded: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
      normalSchools: PropTypes.shape(),
      schools: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    user: PropTypes.shape({
      isSHS: PropTypes.bool.isRequired,
      isGTAPP: PropTypes.bool.isRequired,
      isGT: PropTypes.bool.isRequired,
      isMS: PropTypes.bool.isRequired,
      isK: PropTypes.bool.isRequired,
      isPK: PropTypes.bool.isRequired,
      is2K: PropTypes.bool.isRequired,
      is3K: PropTypes.bool.isRequired,
      address: PropTypes.string.isRequired,
      applicationId: PropTypes.string.isRequired,
      admissionProcess: PropTypes.string.isRequired,
      details: PropTypes.shape({
        data: PropTypes.shape({
          applications: PropTypes.string,
          address: PropTypes.shape({
            latitude: PropTypes.number,
          }),
        }),
      }).isRequired,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    isRtl: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    /*
      TODO CREATE PAGINATION
      isFetching: PropTypes.bool.isRequired,
      // onLoadMoreClick: PropTypes.func.isRequired,
      nextPageUrl: PropTypes.string,
      loadingLabel: PropTypes.string.isRequired,
    */
  };

  static defaultProps = {
    isRtl: false,
  };

  static constants = {
    MAX_NUMBER_SAVED_PROGRAMS_FOR_NOTIFICATIONS: 25,
  };

  constructor(props) {
    super(props);

    this.coachmarksPK = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOnePK)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwoPK)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];
    this.coachmarksPKMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOnePK),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwoPK),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphOne),
      },
    ];

    this.coachmarks3K = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne3K)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwoPK)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];
    this.coachmarks3KMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne3K),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwoPK),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphOne),
      },
    ];

    this.coachmarks2K = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${props.intl.formatMessage(CoachmarksSaved.stepTwoParagraphOne2K)}
        ${props.intl.formatMessage(CoachmarksSaved.stepTwoParagraphTwoPK)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepThree),
      },
    ];
    this.coachmarks2KMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepTwoParagraphOne2K),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepTwoParagraphTwoPK),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepThree),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: props.intl.formatMessage(CoachmarksSaved.stepFourParagraphOne),
      },
    ];

    this.coachmarksHS = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphTwo)}`,
      },
    ];
    this.coachmarksHSMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphOne),
      },
      {
        element: '[data-coachmark="saved-step-4"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepFourParagraphTwo),
      },
    ];

    this.coachmarksMS = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];
    this.coachmarksMSMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];

    this.coachmarksK = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo)}`,
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];
    this.coachmarksKMobile = [
      {
        element: '[data-coachmark="saved-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="saved-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="saved-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSaved.stepThree),
      },
    ];

    switch (props.user.admissionProcess) {
      case 'PK':
        this.coachmarks = this.coachmarksPK;
        this.coachmarksMobile = this.coachmarksPKMobile;
        break;
      case '3K':
        this.coachmarks = this.coachmarks3K;
        this.coachmarksMobile = this.coachmarks3KMobile;
        break;
      case '2K':
        this.coachmarks = this.coachmarks2K;
        this.coachmarksMobile = this.coachmarks2KMobile;
        break;
      case 'K':
        this.coachmarks = this.coachmarksK;
        this.coachmarksMobile = this.coachmarksKMobile;
        break;
      case 'MS':
        this.coachmarks = this.coachmarksMS;
        this.coachmarksMobile = this.coachmarksMSMobile;
        break;
      case 'HS':
        this.coachmarks = this.coachmarksHS;
        this.coachmarksMobile = this.coachmarksHSMobile;
        break;
      default:
        this.coachmarks = null;
        this.coachmarksMobile = null;
    }

    // used to remember which destination was hovered last,
    // so the state is changed only when the first hover is triggered
    this.lastHoverIndex = null;
    this.state = {
      currentSchoolDetail: null,
      currentProgramId: 0,
      // hoveredSchool: false,
      mobileMapIsOpen: false,
      scrollToElement: false,
      applicationLightBox: false,
      sortBy: 'savedAt',
      sortByDirection: 'highToLow',
      isComingFromMobileMap: false,
      loaded: false,
      string: '',
    };
    
  }

  componentDidMount() {
    const { user, dispatch } = this.props;
    const { loaded } = this.state;
    const { applicationId } = user;
    if (loaded) {
      return;
    }

    const getSchoolsProgramsTask = dispatch(getSchoolsPrograms()).catch(error => {
      console.error('Failed to getSchoolsPrograms', error);
    });
    const getFiltersTask = dispatch(getFilters({})).catch(error => {
      console.error('Failed to getFilters', error);
    });
    const studentInfoTask = dispatch(studentInfo(applicationId)).catch(error => {
      console.error('Failed to studentInfo', error);
    });
    const getStudentApplicationsTask = dispatch(getStudentApplications(applicationId)).catch(error => {
      console.error('Failed to getStudentApplications', error);
    });

    Promise.all([
      //
      getSchoolsProgramsTask,
      getFiltersTask,
      studentInfoTask,
      getStudentApplicationsTask,
    ])
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
        });
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.schools.optionsDict !== this.props.schools.optionsDict) {
  //     this.props.getSchoolsPrograms();
  //   }
  // }

  componentDidUpdate(prevProps) {
    // Keep the mobile map mounted once it's been opened: toggling back to the list
    // CSS-hides it instead of unmounting, so reopening doesn't re-fire a map-sessions
    // beacon or hit the broken reuse path. (Mount condition is in render.)
    if (this.state.mobileMapIsOpen && !this.state.mobileMapHasOpened) {
      this.setState({ mobileMapHasOpened: true });
    }
    const { schools, intl, dispatch } = this.props;
    if (prevProps.schools.optionsDict !== schools.optionsDict) {
      dispatch(getSchoolsPrograms());
    }

    if (prevProps.intl.locale !== intl.locale) {
      dispatch(getSchoolsPrograms());
      dispatch(getFilters({}));
    }
  }

  // Example of non-binding

  // onMobileToggleFunction = () => (this.state.mobileRender === SCHOOLS ? this.mobileShowMap : this.mobileShowSchools);

  getMarkers = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    let markers = [];
    if (loading) {
      return markers;
    } else if (loaded) {
      markers = schoolsToMarker(normalSchools, normalSchools.result);
    }
    return markers;
  };

  getFilters = () => {
    const { filters, filtersLoading, filtersLoaded } = this.props;
    let filtersLoad = null;
    if (filtersLoading) {
      filtersLoad = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return filtersLoad;
    } else if (filtersLoaded) {
      filtersLoad = (
        <div className={style.filters}>
          {filters.map(filter => {
            const allOptions = filter.optionGroups.map(({ options }) => options);
            const selected = _.flattenDeep(allOptions)
              // eslint-disable-next-line no-shadow
              .map(({ selected }) => selected)
              .filter(n => n);

            return (
              <FilterSelect
                key={filter.label}
                label={filter.label}
                optionGroups={filter.optionGroups}
                apply={this.handleApplyFilter}
                reset={this.setPage}
                selected={selected.length}
              />
            );
          })}
        </div>
      );
    }
    return filtersLoad;
  };

  setPage = () => {
    const { dispatch } = this.props;
    dispatch(setPage('up'));
    dispatch(getSchoolsPrograms());
  };

  /*
    TODO: write why this is what it is
  */

  getProgramsCount = () => {
    const { normalSchools } = this.props.schools;
    if (normalSchools.result.length) {
      const programList = _.flatten(
        normalSchools.result.map(id => normalSchools.entities.school[id].programs.result.map(programId => programId)),
      );

      return programList.length;
    }
    return 0;
  };

  handleToggleMapForMobileView = ({ isOpen }) => {
    this.setState({
      ...this.state,
      mobileMapIsOpen: isOpen,
    });
  };

  mapClick = () => {};

  mapPlaceholder = () => {
    this.mapClick();
  };

  handleApplyFilters = ({ filters }) => {
    const { dispatch } = this.props;
    const realOptionGroups = [];
    filters.map(({ optionGroups }) =>
      optionGroups.map(item => {
        realOptionGroups.push(item);
        return item;
      }),
    );

    dispatch(addParameterAndSearch(realOptionGroups));
  };

  handleApplyFilter = ({ optionGroups }) => {
    const { dispatch } = this.props;
    if(optionGroups.search){
      this.setState({
        string: optionGroups.search[0]
      }, () => {dispatch(addParameterAndSearch(optionGroups));});
    }
    else{
      dispatch(addParameterAndSearch(optionGroups));
    }      
  };

  handleCloseDetailView = () => {
    const { isComingFromMobileMap } = this.state;
    this.setState({
      currentSchoolDetail: null,
      currentProgramId: 0,
      mobileMapIsOpen: !!isComingFromMobileMap,
      isComingFromMobileMap: false,
    });

    const { pathname } = history.location;
    history.push(pathname);
  };

  handleProgramClick = (id, schoolId) => {
    const { currentProgramId, currentSchoolDetail, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    // sk: if we are in school detail
    // all user interactions are intentional
    if (id === currentProgramId) {
      this.setState({
        ...this.state,
        currentProgramId: 1,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
    } else {
      this.setState({
        ...this.state,
        currentSchoolDetail: schoolId,
        currentProgramId: id,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
    }

    if (currentSchoolDetail !== schoolId) {
      const { pathname } = history.location;
      history.push(`${pathname}?id=${schoolId}`);
    }

    document.body.style.overflow = 'initial';
  };

  handleSchoolClick = id => {
    const { currentSchoolDetail, currentProgramId, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    if (currentSchoolDetail === id) {
      // CURRENT SCHOOL
      if (currentProgramId) {
        // clicking a school map title AND we have a program open
        this.setState({
          ...this.state,
          currentProgramId: 0,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      } else {
        // clicking the school map title when school card is open and no program is open
        this.setState({
          ...this.state,
          currentSchoolDetail: id,
          currentProgramId: 1,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      }
    } else {
      const { pathname } = history.location;
      history.push(`${pathname}?id=${id}`);
      this.setState({
        ...this.state,
        currentSchoolDetail: id,
        currentProgramId: 0,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
      setTimeout(function(){
        window.scrollTo(0, 0)
      }, 1000);
    }
    document.body.style.overflow = 'initial';
  };

  handleSort = ({ sortBy, sortByDirection }) => {
    this.setState({
      ...this.state,
      sortBy,
      sortByDirection,
    });
  };

  showAutocompleteSchoolDetail = string => {
    const { autocompleteList, id } = this.props.schools.autocomplete.savedProgramSchoolsUnapplied;
    const schoolId = id[autocompleteList.indexOf(string)];
    this.handleSchoolClick(schoolId);
  };

  renderSchools = () => {
    const { normalSchools, loading } = this.props.schools;
    const { user, schools } = this.props;
    const { admissionProcess } = user;
    const { currentSchoolDetail, currentProgramId, sortBy, sortByDirection } = this.state;
    let load = null;
    if (loading) {
      load = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return load;
    }

    if (currentSchoolDetail !== null) {
      return (
        <ul className={style.list}>
          <li key="detail" className={style.listItem}>
            <School
              {...normalSchools.entities.school[currentSchoolDetail]}
              loggedIn
              onClick={this.handleSchoolClick}
              showDetails
              headerOpen={!currentProgramId}
              programOpen={currentProgramId}
              programClick={this.handleProgramClick}
              user={user}
              admissionProcess={admissionProcess}
            />
          </li>
        </ul>
      );
    }

    if (!normalSchools.result.length) {
      if (getSavedProgramCount(schools.schools) === 0) {
        return null;
      }
      return <SearchNoResults />;
    }

    let programList = _.flatten(
      normalSchools.result.map(id =>
        normalSchools.entities.school[id].programs.result.map(programId => ({
          schoolId: id,
          programId,
          distance: parseFloat(normalSchools.entities.school[id].distance),
          savedAt: normalSchools.entities.school[id].programs.entities.program[programId].saved_at,
        })),
      ),
    );

    if (sortBy !== null) {
      if (sortByDirection === 'lowToHigh') {
        programList = programList.sort((a, b) => a[sortBy] - b[sortBy]);
      } else {
        programList = programList.sort((a, b) => b[sortBy] - a[sortBy]);
      }
    }
    return (
      <ul className={style.list}>
        {programList.map(({ schoolId, programId }) => (
          <li key={`${schoolId}-${programId}`} className={style.listItem}>
            <School
              {...normalSchools.entities.school[schoolId]}
              loggedIn
              singleProgramId={programId}
              onClick={this.handleSchoolClick}
              programClick={this.handleProgramClick}
              admissionProcess={admissionProcess}
            />
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { filters, intl, user, schools } = this.props;
    const { autocompleteList } = schools.autocomplete.savedProgramSchoolsUnapplied;
    const {
      //
      // hoveredSchool,
      mobileMapIsOpen,
      currentSchoolDetail,
      isComingFromMobileMap,
      loaded,
    } = this.state;

    if (!loaded) {
      return <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    }

    const sidebarClasses = [style.sidebar];
    const mapClasses = [style.map];
    // const alertBoxClasses = [style.alertBox];
    const savedProgramsCount = getSavedProgramCount(schools.schools);
    const freeProgramsSlot = savedProgramsCount ? 25 - savedProgramsCount : 25;
    const alertBoxLink = `/${intl.locale}/dashboard/${user.applicationId}/schools/`;
    const alertBoxApplyLink = `/${intl.locale}/dashboard/${user.applicationId}/apply/`;
    const noSavedPrograms = savedProgramsCount === 0;
    const savedPrograms =
      !noSavedPrograms && savedProgramsCount < Saves.constants.MAX_NUMBER_SAVED_PROGRAMS_FOR_NOTIFICATIONS;

    if (mobileMapIsOpen) {
      sidebarClasses.push(style.sidebarMapIsClicked);
      mapClasses.push(style.mapMapIsClicked);
    }

    if (noSavedPrograms) {
      sidebarClasses.push(style.sidebarMapIsHidden);
    }

    const backButtonLabel = isComingFromMobileMap
      ? customisedIntlFormatMessage(intl, messages.generalStringBackToMap)
      : customisedIntlFormatMessage(intl, messages.generalStringBackToList);

    const mapProps = {
      ...this.props,
      markers: this.getMarkers(),
      popupClickHandlers: {
        onSchoolNameClick: this.handleSchoolClick,
        onProgramClick: this.handleProgramClick,
      },
      currentSchoolDetail,
    };

    let studentAddressNotGeocoded = null;
    if (user.details.data.applications && (!user.details.data.address || !user.details.data.address.latitude)) {
      studentAddressNotGeocoded = (
        <div className={style.geolocationWarning}>
          <FormattedMessage {...localMessages.studentAddressNotGeocoded} />
        </div>
      );
    }
    
    return (
      <main className={style.root} role="presentation">
        {!currentSchoolDetail && (
          <Mobile>
            {!noSavedPrograms && (
              <div data-coachmark="saved-step-1">
                <SearchAndFilter
                  filters={filters}
                  toggleMap={this.handleToggleMapForMobileView}
                  mapIsOpen={mobileMapIsOpen}
                  apply={this.handleApplyFilters}
                  searchfieldOnSearch={this.handleApplyFilter}
                  autocomplete={false}
                  user={user}
                  display={this.state.string}
                />
              </div>
            )}
          </Mobile>
        )}
        <div className={style.flexRoot}>
          <div className={classNames(...sidebarClasses)}>
            {studentAddressNotGeocoded}
            {!currentSchoolDetail && (
              <Fragment>
                <Default>
                  <div className={style.pageLabel}>
                    <i className="icon-Star" role="presentation" />
                    <h1>
                      <FormattedMessage {...messages.generalStringYourSavedPrograms} />
                    </h1>
                  </div>
                  {!noSavedPrograms && (
                    <div data-coachmark="saved-step-1">
                      <SearchField
                        onClick={this.showAutocompleteSchoolDetail}
                        placeholder={messages.searchfieldPlaceholderSavedPrograms}
                        onSearch={this.handleApplyFilter}
                        items={autocompleteList}
                        autocomplete={false}
                        user={user}
                        display={this.state.string}
                      />
                      {this.getFilters()}
                    </div>
                  )}
                  {noSavedPrograms && (
                    <div className={style.alertBox}>
                      <span className={style.alertBoxText}>
                        <FormattedMessage
                          {...localMessages.noSavedProgramsAlertBoxBeforeLinkText}
                          className={style.alertBox}
                        />
                        <a href={alertBoxLink}>
                          <FormattedMessage
                            {...localMessages.savedProgramsAlertBoxLinkText}
                            className={style.alertBox}
                          />
                        </a>
                        <FormattedMessage
                          {...localMessages.noSavedProgramsAlertBoxAfterLinkText}
                          className={style.alertBox}
                        />
                        <br />
                        <br />
                        <FormattedMessage
                          {...localMessages.noSavedProgramsAlertBoxAdditionalBeforeLinkText}
                          className={style.alertBox}
                        />
                        <a href={alertBoxApplyLink}>
                          <FormattedMessage
                            {...localMessages.noSavedProgramsAlertBoxApplyLinkText}
                            className={style.alertBox}
                          />
                        </a>
                        <FormattedMessage
                          {...localMessages.noSavedProgramsAlertBoxAdditionalAfterLinkText}
                          className={style.alertBox}
                        />
                      </span>
                    </div>
                  )}
                  {(savedPrograms || !noSavedPrograms) &&
                    !user.isMS &&
                    !user.isK &&
                    !user.isGTAPP &&
                    !user.isPK &&
                    !user.is2K &&
                    !user.is3K && (
                      <div>
                        {savedPrograms && (
                          <div className={style.alertBox} data-coachmark="saved-step-4">
                            <span className={style.alertBoxText}>
                              <FormattedMessage
                                {...localMessages.savedProgramsAlertBoxBeforeLinkText}
                                className={style.alertBox}
                                values={{ savedProgramsCount }}
                              />
                              <a href={alertBoxLink}>
                                <FormattedMessage
                                  {...localMessages.savedProgramsAlertBoxLinkText}
                                  className={style.alertBox}
                                />
                              </a>
                              <FormattedMessage
                                {...localMessages.savedProgramsAlertBoxAfterLinkText}
                                className={style.alertBox}
                                values={{ freeProgramsSlot }}
                              />
                            </span>
                          </div>
                        )}
                        {!noSavedPrograms && (
                          <ResultsSetSort count={this.getProgramsCount()} onSort={this.handleSort} type="programs" />
                        )}
                      </div>
                    )}
                  {(savedPrograms || !noSavedPrograms) &&
                    (user.isMS || user.isK || user.isPK || user.is2K || user.is3K) && (
                      <div>
                        <ResultsSetSort count={this.getProgramsCount()} onSort={this.handleSort} type="programs" />
                      </div>
                    )}
                </Default>
                <Mobile>
                  {noSavedPrograms &&
                    !schools.loading && (
                      <div className={style.alertBox}>
                        <span className={style.alertBoxText}>
                          <FormattedMessage
                            {...localMessages.noSavedProgramsAlertBoxBeforeLinkText}
                            className={style.alertBox}
                          />
                          <a href={alertBoxLink}>
                            <FormattedMessage
                              {...localMessages.savedProgramsAlertBoxLinkText}
                              className={style.alertBox}
                            />
                          </a>
                          <FormattedMessage
                            {...localMessages.noSavedProgramsAlertBoxAfterLinkText}
                            className={style.alertBox}
                          />
                          <br />
                          <br />
                          <FormattedMessage
                            {...localMessages.noSavedProgramsAlertBoxAdditionalBeforeLinkText}
                            className={style.alertBox}
                          />
                          <a href={alertBoxApplyLink}>
                            <FormattedMessage
                              {...localMessages.noSavedProgramsAlertBoxApplyLinkText}
                              className={style.alertBox}
                            />
                          </a>
                          <FormattedMessage
                            {...localMessages.noSavedProgramsAlertBoxAdditionalAfterLinkText}
                            className={style.alertBox}
                          />
                        </span>
                      </div>
                    )}
                  {(savedPrograms || !noSavedPrograms) &&
                    !user.isMS &&
                    !user.isK &&
                    !user.isPK &&
                    !user.is2K &&
                    !user.is3K && (
                      <div>
                        {savedPrograms && (
                          <div className={style.alertBox} data-coachmark="saved-step-4">
                            <span className={style.alertBoxText}>
                              <FormattedMessage
                                {...localMessages.savedProgramsAlertBoxBeforeLinkText}
                                className={style.alertBox}
                                values={{ savedProgramsCount }}
                              />
                              <a href={alertBoxLink}>
                                <FormattedMessage
                                  {...localMessages.savedProgramsAlertBoxLinkText}
                                  className={style.alertBox}
                                />
                              </a>
                              <FormattedMessage
                                {...localMessages.savedProgramsAlertBoxAfterLinkText}
                                className={style.alertBox}
                                values={{ freeProgramsSlot }}
                              />
                            </span>
                          </div>
                        )}
                        {!noSavedPrograms && (
                          <div className={style.resultSetSortWrapper}>
                            <ResultsSetSort count={this.getProgramsCount()} onSort={this.handleSort} type="programs" />
                          </div>
                        )}
                      </div>
                    )}
                  {(savedPrograms || !noSavedPrograms) &&
                    (user.isMS || user.isK || user.isPK || user.is2K || user.is3K) && (
                      <div>
                        <ResultsSetSort count={this.getProgramsCount()} onSort={this.handleSort} type="programs" />
                      </div>
                    )}
                </Mobile>
              </Fragment>
            )}
            {currentSchoolDetail && (
              <div className={style.backButtonWrapper}>
                <Default>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Default>
                <Mobile>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={backButtonLabel}
                    label={backButtonLabel}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Mobile>
              </div>
            )}
            {this.renderSchools()}
          </div>
          {!noSavedPrograms && (
            <div className={classNames(...mapClasses)}>
              <Default>
                <Mapbox {...mapProps} />
              </Default>
              <Mobile>
                {/* Lazy-mount the mobile map: don't instantiate mapbox-gl (a billable map
                    load) until the user first opens the map view. Once opened, keep it
                    mounted (visibility is CSS-toggled) so reopening doesn't re-initialize a
                    new map — avoids an extra map-sessions beacon and the broken-reuse path. */}
                {(mobileMapIsOpen || this.state.mobileMapHasOpened) && <Mapbox {...mapProps} mobile />}
              </Mobile>
            </div>
          )}
        </div>
        {schools.loaded &&
          this.coachmarks &&
          this.coachmarksMobile &&
          !noSavedPrograms && (
            <div>
              <Default>
                <Coachmarks steps={this.coachmarks} context="saved" />
              </Default>
              <Mobile>
                <Coachmarks steps={this.coachmarksMobile} context="saved" />
              </Mobile>
            </div>
          )}
      </main>
    );
  }
}

const mapStateToProps = ({ schools, filters, user }) => ({
  schools,
  user,
  ...filters,
});

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(Saves);
